module.exports = __webpack_public_path__ + "static/medical-equipment-1-691d0f2d7a020fdf4aacf60de532914d.jpg";